<template>
    <v-autocomplete
        v-model="searchModel"
        :items="itemsList"
        hide-no-data
        :item-text="itemText || defaultItemTextPropertyName"
        item-value="value"
        :label="componentLabel"
        @change="valueChange"
        return-object
        color="orange lighten-2"
        item-color="orange lighten-2"
        clearable
        :attach="`#${searchName}`"
    >
        <template v-slot:append-outer>
            <div :id="searchName"></div>
        </template>
        <template v-slot:selection="data">
            {{ data.item[defaultItemTextPropertyName] }}
        </template>
    </v-autocomplete>
</template>

<script>
    import BaseSimpleAutocomplete from '../../../general/mixins/BaseSimpleAutocomplete';

    export default {
        name: "BaseSearch",
        mixins:[BaseSimpleAutocomplete],
        props:['searchName', 'attributeName'],
        data() {
            return {
                params: {
                    categoryId: this.categoryId
                }
            }
        },
        computed: {
            filterName() {
                return this.$store.state.filters.general[this.searchName].systemName;
            }
        },
        created() {
            this.checkInitial();
        }
    }
</script>

<style scoped>

</style>
